// Deprecated

'use strict';

module.exports = function (obj) { return typeof obj === 'function'; };



/*****************
 ** WEBPACK FOOTER
 ** /Users/gaearon/p/react-devtools/~/es5-ext/object/is-callable.js
 ** module id = 205
 ** module chunks = 0
 **/